import $ from "jquery";
import "./vendor/jquery-migrate-1.4.1.js";
import "./vendor/royalslider/jquery.easing-1.3.js";
import "./vendor/royalslider/jquery.royalslider.js";
import "./vendor/royalslider/modules/jquery.rs.autoplay.js";
import "./vendor/bootstrap.min.js";

//jQuery URL Parameters function
jQuery.fn.extend({
	/**
	 * Returns get parameters.
	 *
	 * If the desired param does not exist, null will be returned
	 *
	 * To get the document params:
	 * @example value = $(document).getUrlParam("paramName");
	 *
	 * To get the params of a html-attribut (uses src attribute)
	 * @example value = $('#imgLink').getUrlParam("paramName");
	 */
	getUrlParam: function (strParamName) {
		strParamName = escape(unescape(strParamName));

		var returnVal = new Array();
		var qString = null;

		if ($(this).attr("nodeName") == "#document") {
			//document-handler

			if (window.location.search.search(strParamName) > -1) {
				qString = window.location.search
					.substr(1, window.location.search.length)
					.split("&");
			}
		} else if ($(this).attr("src") != "undefined") {
			var strHref = $(this).attr("src");
			if (strHref.indexOf("?") > -1) {
				var strQueryString = strHref.substr(strHref.indexOf("?") + 1);
				qString = strQueryString.split("&");
			}
		} else if ($(this).attr("href") != "undefined") {
			var strHref = $(this).attr("href");
			if (strHref.indexOf("?") > -1) {
				var strQueryString = strHref.substr(strHref.indexOf("?") + 1);
				qString = strQueryString.split("&");
			}
		} else {
			return null;
		}

		if (qString == null) return null;

		for (var i = 0; i < qString.length; i++) {
			if (escape(unescape(qString[i].split("=")[0])) == strParamName) {
				returnVal.push(qString[i].split("=")[1]);
			}
		}

		if (returnVal.length == 0) return null;
		else if (returnVal.length == 1) return returnVal[0];
		else return returnVal;
	},
});

// Avoid `console` errors in browsers that lack a console.
if (!(window.console && console.log)) {
	(function () {
		var noop = function () {};
		var methods = [
			"assert",
			"clear",
			"count",
			"debug",
			"dir",
			"dirxml",
			"error",
			"exception",
			"group",
			"groupCollapsed",
			"groupEnd",
			"info",
			"log",
			"markTimeline",
			"profile",
			"profileEnd",
			"markTimeline",
			"table",
			"time",
			"timeEnd",
			"timeStamp",
			"trace",
			"warn",
		];
		var length = methods.length;
		var console = (window.console = {});
		while (length--) {
			console[methods[length]] = noop;
		}
	})();
}

// scroll top bottom plugin
(function () {
	var special = jQuery.event.special,
		uid1 = "D" + +new Date(),
		uid2 = "D" + (+new Date() + 1);

	special.scrollstart = {
		setup: function () {
			var timer,
				handler = function (evt) {
					var _self = this,
						_args = arguments;

					if (timer) {
						clearTimeout(timer);
					} else {
						evt.type = "scrollstart";
						jQuery.event.handle.apply(_self, _args);
					}

					timer = setTimeout(function () {
						timer = null;
					}, special.scrollstop.latency);
				};

			jQuery(this).bind("scroll", handler).data(uid1, handler);
		},
		teardown: function () {
			jQuery(this).unbind("scroll", jQuery(this).data(uid1));
		},
	};

	special.scrollstop = {
		latency: 300,
		setup: function () {
			var timer,
				handler = function (evt) {
					var _self = this,
						_args = arguments;

					if (timer) {
						clearTimeout(timer);
					}

					timer = setTimeout(function () {
						timer = null;
						evt.type = "scrollstop";
						jQuery.event.handle.apply(_self, _args);
					}, special.scrollstop.latency);
				};

			jQuery(this).bind("scroll", handler).data(uid2, handler);
		},
		teardown: function () {
			jQuery(this).unbind("scroll", jQuery(this).data(uid2));
		},
	};
})();

jQuery.ajaxSetup({
	cache: true,
});

// commenting this out for now because screw it
// // Javascript to enable link to tab
if (window.location.hash.length > 0 && document.querySelectorAll('.nav-tabs').length > 0 && document.getElementById('scheduleFull') == null) {
	$(`.nav-tabs a[href=${window.location.hash}]`).tab('show');
}

// Change hash for page-reload
$(".nav-tabs a").on("shown.bs.tabs", function (e) {
	window.location.hash = e.target.hash;
});

// Lets clean up the JS and only load libraries/plugins if we need them
// We have to use a timeout here because firefox is awful at loading
$(document).ready(function () {
	//Initializing MyFonts kit
	//if ($("body").length > 0) {

	//$.getScript("/library/js/rd/vendor/MyFontsWebfontsKit.js", function () {});
	//}
	//Lets initialize the Lightbox now if we need it
	if ($(".lightbox").length > 0) {
		//Lets load up the CSS for the Lightbox since we'll need it here
		$("head").append("<link>");
		css = $("head").children(":last");
		css.attr({
			rel: "stylesheet",
			type: "text/css",
			href:
				"/library/js/rd/vendor/lightbox/themes/evolution/jquery.lightbox.css",
		});
		$.getScript(
			"/library/js/rd/vendor/lightbox/jquery.lightbox.min.js",
			function () {
				setTimeout(function () {
					$(".lightbox").lightbox();
				}, 100);
			}
		);
	}
	//Now for an involved one, lets load up the slider code
	if ($(".royalSlider").length > 0) {
		//Lets try to only init the sliders we need
		//Landing Page Slider
		if ($("#landingSlider").length > 0) {
			$("#landingSlider").royalSlider({
				arrowsNav: true,
				autoScaleSlider: true,
				autoScaleSliderWidth: 1410,
				autoScaleSliderHeight: 716,
				arrowsNavAutoHide: false,
				fadeinLoadedSlide: false,
				imageScaleMode: "fill",
				controlNavigationSpacing: 0,
				controlNavigation: "bullets",
				blockLoop: true,
				loop: true,
				numImagesToPreload: 6,
				transitionType: "fade",
				keyboardNavEnabled: true,
				block: {
					delay: 400,
				},
				autoPlay: {
					// autoplay options go here
					enabled: true,
					pauseOnHover: true,
					delay: 4000,
				},
			});
		}
		if ($("#sponsorSlider").length > 0) {
			$("#sponsorSlider").royalSlider({
				arrowsNav: false,
				imageAlignCenter: true,
				loop: true,
				transitionType: "fade",
				block: {
					delay: 400,
				},
				autoPlay: {
					enabled: true,
					pauseOnHover: true,
					delay: 4000,
				},
			});
		}
	}
});
//Tooltips simply give the class name and add a title to an element

$(".tip-top").tooltip({
	placement: "top",
});
$(".tip-bottom").tooltip({
	placement: "bottom",
});
$(".tip-left").tooltip({
	placement: "left",
});
$(".tip-right").tooltip({
	placement: "right",
});

//Navigation Sub Menus

//Lets fix up those accordion icons.
$(function () {
	//If someone expands/shows the content lets adjust the icon
	$("#panel-resources").on("shown.bs.collapse", function () {
		$("i.icon-chevron-right").toggleClass(
			"icon-chevron-right icon-chevron-down"
		);
	});
	$("#panel-resources").on("hidden.bs.collapse", function () {
		$("i.icon-chevron-down").toggleClass(
			"icon-chevron-down icon-chevron-right"
		);
	});
	$(".collapse")
		.on("show.bs.collapse", function () {
			$(this)
				.parent()
				.find(".icon-plus")
				.removeClass("icon-plus")
				.addClass("icon-minus");
			$(this)
				.parent()
				.find('.fa-plus')
				.toggleClass('fa-minus fa-plus');
		})
		.on("hide.bs.collapse", function () {
			$(this)
				.parent()
				.find(".icon-minus")
				.removeClass("icon-minus")
				.addClass("icon-plus");
				$(this)
				.parent()
				.find('.fa-minus')
				.toggleClass('fa-minus fa-plus');
		});
});

// toggle-all button functionality for FAQ
$(function(){
	if ($('.js-toggle-all').length > 0) {
		$('.js-toggle-all').on('click', function() {
			$('.collapse').collapse('show');
		})
	}
});

// scroll top
$(document).ready(function () {
	$(window).scroll(function () {
		if ($(this).scrollTop() > 100) {
			$(".scrollup").fadeIn();
		} else {
			$(".scrollup").fadeOut();
		}
	});

	$(".scrollup").click(function () {
		$("html, body").animate(
			{
				scrollTop: 0,
			},
			600
		);
		return false;
	});
});

// Hover effect for home page feature blocks
$("#actionsidebar li").on({
	mouseenter: function () {
		$(this).addClass("hover-block");
	},
	mouseleave: function () {
		$(this).removeClass("hover-block");
	},
});

// invited speaker selection script
$(document).ready(function () {
	$("#trackSelector").on("change", function (event) {
		var selectedTrack = event.target.value;
		// hide existing tabs
		$(".tab-pane").removeClass("active in");
		// bring in selected tab
		$(selectedTrack).addClass("active in");
	});
});

// maintenance popup work
// show maintenance window message unless flag in sessionStorage is set
$(document).ready(function () {
	var showMaintenanceWindow =
		sessionStorage.getItem("showMaintenanceWindow") || "true";
	if (
		document.querySelector(".maintenance-popup") &&
		showMaintenanceWindow === "true"
	) {
		document.querySelector(".maintenance-popup").classList.remove("hidden");
	}
});

// click listener called by button's OnClientClick method
function HideMaintenancePopup() {
	sessionStorage.setItem("showMaintenanceWindow", "false");
	document.querySelector(".maintenance-popup").classList.add("hidden");
	return false; // prevent postback
}

// invited speaker JS
// add
if (document.getElementById("track-select")) {

	var trackSelectorEl = document.getElementById("track-select");
	trackSelectorEl.addEventListener("change", function (event) {
		var selectedTrack = "#" + event.target.value;
		$(".tab-pane").removeClass("active in");
		$(selectedTrack).addClass("active in");
	});

	// check querystring for track querystring
	if (window.location.search.length > 0 && window.location.search.indexOf('track') > -1) {
		var initialTrack = new URLSearchParams(window.location.search).get('track');
		var optArr = Array.from(trackSelectorEl.options);
		var selectedOpt = optArr.find(el => el.value.localeCompare(initialTrack, 'en', { sensitivity: 'accent' }) == 0);
		if (typeof selectedOpt != 'undefined') {
			selectedOpt.selected = true;
			trackSelectorEl.dispatchEvent(new Event('change'));
		}
	}
}

// basic query string parsing for ie11.

function getUrlParameter(name) {
	name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
	var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
	var results = regex.exec(location.search);
	return results === null
		? ""
		: decodeURIComponent(results[1].replace(/\+/g, " "));
}

// tab anchor handler
// if a link contains the following parameters:
// tab = tabid
// it will open the specified tab on load

$(document).ready(function () {
	if (getUrlParameter("tabid")) {
		var linkedTab = "a[href=#" + getUrlParameter("tabid") + "]";
		$(linkedTab).tab("show");
	}
});

// schedule modal JS
$(document).ready(() => {
	if ($('#scheduleModal').length > 0) {
		$('#scheduleModal').on('show.bs.modal', event => {
			let dataEl = $($(event.relatedTarget).data('container'));
			$('#scheduleModalTitle').text(dataEl[0].dataset.title);
			$('#scheduleModalBody').html(dataEl[0].innerHTML);
		});
	}
});

// zoom link
// redirects to schedule and opens zoom in new tab
// TODO: rename class to .js-zoom-redirect to make what the class does explicit
// and change transformations, not JS
// otherwise we'll have to keep adding exceptions whenever people think to add the zoom link elsewhere.
$(function() {
	if($('.js-zoom-link').length > 0 && !window.location.href.includes('short-courses')) {
		$('.js-zoom-link').on('click', event => {
			event.preventDefault();
			window.open($('.js-zoom-link').attr('href'), '_blank');
			window.location = '/home/schedule';
		})
	}
});

// Flickity for Schedule Page
$(function() {
	if (document.getElementById('ScheduleFull') != null) {
		// set constants
		const savedScheduleKey = 'savedScheduleToggle';
		const scheduleToggle = document.getElementById('scheduleToggle');
		let initialScheduleToggleValue = localStorage.getItem(savedScheduleKey);
		let useFlickity;
		if (initialScheduleToggleValue == 'true') {
			useFlickity = true;
			scheduleToggle.checked = true;
		}
		else {
			useFlickity = false;
			scheduleToggle.checked = false;
		}

		const cellClass = 'session-block';
		const sessionsSliders = Array.from(document.querySelectorAll('.concurrent-sessions'));
		const initialItemID = window.location.hash;
		let sliders = [];
		const getInitialIndexSelector = id => {
			if (id.length == 0) return "";
			let linkedEl = document.getElementById(id);
			if (linkedEl != null) {
				return linkedEl.closest(`.${cellclass}`).id;
			}
			return "";
		};
		const initFlickityFromArray = function(elementArray) {
			return elementArray.map(el => {
				return new Flickity(el, {
					freeScroll: false,
					wrapAround: false,
					autoPlay: false,
					cellSelector: `.${cellClass}`,
					accessibility: true,
					prevNextButtons: el.querySelectorAll(`.${cellClass}`).length > 1,
					pageDots: false,
					on: {
						ready: function() {
							el.parentElement.querySelector('.schedule-slide-message').classList.add('is-visible');
							el.classList.add('is-visible');
						}
					},
					initialIndex: initialItemID.length > 0 ? getInitialIndexSelector(initialItemID) : 0
				});
			})
		};

		if (useFlickity) {
			sliders = initFlickityFromArray(sessionsSliders);
		} else {
			sessionsSliders.forEach(element => element.classList.add('is-visible'));
		}

		scheduleToggle.addEventListener('change', event => {
			// if checkbox was checked and flickity was enabled
			if (!event.target.checked && sliders.length > 0) {
				sliders.forEach(flickityInstance => {
					// deactivate flickity and save setting to localStorage
						flickityInstance.destroy();
						localStorage.setItem(savedScheduleKey, 'false');
					});
					// wipe out existing cache of flickity items
					sliders = [];
				} else if (event.target.checked && sliders.length == 0) {
					console.log('initializing flickity');
					sliders = initFlickityFromArray(sessionsSliders);
					localStorage.setItem(savedScheduleKey, 'true');
			}
		});
	}
});

// Scroll to found session if session hash is present in URL
$(function() {
	const initialItemID = window.location.hash;
	const searchedEl = document.getElementById(initialItemID.replace('#', '').toLowerCase());
	if (searchedEl != null && document.getElementById('ScheduleFull') != null) {
		setTimeout(() => {
			searchedEl.parentElement.scrollIntoView({
			block: "center",
			inline: "center",
			behavior: "smooth"
			});
		}, 500);
		let parentSliderObject = Flickity.data(searchedEl.closest('.concurrent-sessions'));
		searchedEl.classList.add('is-found');
		parentSliderObject.selectCell('.is-found', false, false);
	}
});

// avoid user dropdown closing when selecting timezone
$(function() {
	const userTimeZoneSelect = $('#userTimeZoneSelect');

	if (userTimeZoneSelect.length == 0) {
		return;
	}

	userTimeZoneSelect.on('click', event => event.stopPropagation());
});

// trigger flickity resize when poster collapse panels are expanded.
function resizeFlickityElement(event) {
	console.log('resizing element:', event.target);
	return Flickity.data(event.target).resize();
}

$(() => {
	const posterCollapsePanels = $('.js-poster-collapse-target');
	if (posterCollapsePanels.length > 0) {
		posterCollapsePanels.on('shown.bs.collapse hidden.bs.collapse', event => {
			let flickityElement = event.target.closest('.concurrent-sessions.flickity-enabled');
				Flickity.data(flickityElement).resize();
				const collapseLink = $(`a[href='#${event.target.id}']`);
				if (event.type === "shown") {
					collapseLink.text("Shrink Poster Listing");
				}
				else {
					collapseLink.text("Expand Poster Listing");
				}
		});
	}
});
